import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Sider
import Forside from './pages/Forside';
import Produkter from './pages/Produkter';
import OmOs from './pages/OmOs';
import GalleriPage from './pages/GalleriPage';
import Kontakt from './pages/Kontakt';
import Privatlivspolitik from './pages/Privatlivspolitik';
import Handelsbetingelser from './pages/Handelsbetingelser';
import Error404 from './pages/Error404';
import Error403 from './pages/Error403';

function App() {
  return (
    <>
      {/* Sikrer scroll restoration ved ruteskift */}
      <ScrollToTop />

      <div className="flex flex-col min-h-screen bg-cream-bg text-choc-dark antialiased selection:bg-berry-accent/20 selection:text-choc-dark">
        {/* Navigation */}
        <Header />

        {/* Hovedindhold */}
        <main className="flex-grow">
          <Routes>
            {/* Forside */}
            <Route path="/" element={<Forside />} />

            {/* Produkter (Både overordnet og specifikke kategorier) */}
            <Route path="/produkter" element={<Navigate to="/produkter/chokolade" replace />} />
            <Route path="/produkter/:category" element={<Produkter />} />

            {/* Om os */}
            <Route path="/om-os" element={<OmOs />} />

            {/* Galleri */}
            <Route path="/galleri" element={<GalleriPage />} />

            {/* Kontakt */}
            <Route path="/kontakt" element={<Kontakt />} />

            {/* Juridiske sider */}
            <Route path="/privatlivspolitik" element={<Privatlivspolitik />} />
            <Route path="/handelsbetingelser" element={<Handelsbetingelser />} />

            {/* Fejlsider */}
            <Route path="/403" element={<Error403 />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}

export default App;
